<script setup>
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const route = useRoute()
const pageInfo = computed(() => pageConfig[route.params.rvrsys])
const prefText = computed(() => {
  return pageInfo.value.pref_list
    .filter(Boolean)
    .map((p) => p.replace(/[都府県]$/, ''))
    .join('・')
})
if (!pageInfo.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'River System Page Not Found'
  })
}
const breadCrumbList = isWebViewFlag ? [] : getBreadCrumb('river', pageInfo.value.name)
useCustomMeta('river', pageInfo.value.name, prefText.value)
const { data: pointList } = await useAsyncData(
  `river-point-list-${route.params.rvrsys}`,
  () => $fetch('/api/river/rvrsys/pointlist', {
    query: {
      path: route.params.rvrsys
    }
  }),
  { watch: [() => route.params.rvrsys] }
)
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <CommonPageTitle :title="`${pageInfo.name}水系の河川水位情報（${prefText}）`" />
        <RiverFocusMap :point-list="pointList" />
      </div>
      <template #main-bottom>
        <RiverCameraList :page-info="pageInfo" />
        <RiverSearch />
        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
        <TopicList />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
